import React, { Component } from "react";
import { FieldRow } from 'common';
import * as actions from '../redux/supervisor_time_off_actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { default as PendingTab } from "./PendingTab";
import { default as RequestTabContent } from "./RequestTabContent";
import {default as SupervisorTimeOffRequestModal} from "../Modals/SupervisorTimeOffRequestModal"

export class TabContainer extends Component {
    constructor(props) {
		super(props);
        
        let { TabType } = this.props;

        this.state = {
            TabType: TabType,
            tabs : [
                { path: '/TimeOff/Pending', name: "Pending", active: TabType === "Pending"},
                { path: '/TimeOff/Approved', name: "Approved", active: TabType === "Approved" },
                { path: '/TimeOff/Canceled', name: "Canceled", active: TabType === "Canceled" },
                { path: '/TimeOff/Denied', name: "Denied", active: TabType === "Denied" }
              ],
            ManagementUnitID: props.ManagementUnitID,
            isRefreshNeeded: props.isRefreshNeeded ? props.isRefreshNeeded : false
        }

        this.renderTabs = this.renderTabs.bind(this);
        this.showEditModal = this.showEditModal.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.TabType !== nextProps.TabType) {
            
            this.setState({
                TabType: nextProps.TabType,
                tabs : [
                    { path: '/TimeOff/Pending', name: "Pending", active: nextProps.TabType === "Pending" },
                    { path: '/TimeOff/Approved', name: "Approved", active: nextProps.TabType === "Approved" },
                    { path: '/TimeOff/Canceled', name: "Canceled", active: nextProps.TabType === "Canceled"  },
                    { path: '/TimeOff/Denied', name: "Denied", active: nextProps.TabType === "Denied" }
                  ]               
            });
        }
        if(this.props.ManagementUnitID !== nextProps.ManagementUnitID){
            this.setState({
                ManagementUnitID: nextProps.ManagementUnitID
            })
        }
        if(this.props.isRefreshNeeded !== nextProps.isRefreshNeeded){
            this.setState({
                isRefreshNeeded: nextProps.isRefreshNeeded
            })
        }
    }

    toggleModal() {
        this.setState({ 
            showModal: !this.state.showModal,
            timeOffRequest: null
		});
    }

    showEditModal(rowData) {
        this.setState({ 
            showModal: true,
            timeOffRequest: rowData
		});
    }
    
    renderTabs() {
        
        if(this.state.TabType) {
            
            if(this.state.TabType === "Approved") {
                return <RequestTabContent title="Approved Requests" 
                            editTimeOffRequestOnClick={this.showEditModal}
                            status={this.state.TabType}/>
            }
            else if(this.state.TabType === "Pending") {
                return <PendingTab 
                            ManagementUnitID = {this.state.ManagementUnitID}
                            isRefreshNeeded = {this.state.isRefreshNeeded} />
            }
            else if(this.state.TabType === "Canceled") {
                return <RequestTabContent title="Canceled Requests"                             
                            status={this.state.TabType}/>
            }
            else if(this.state.TabType === "Denied") {
                return <RequestTabContent title="Denied Requests"
                            editTimeOffRequestOnClick={this.showEditModal}
                            status={this.state.TabType}/>
            }
        }
    }

    render() {
        let {showModal, ManagementUnitID} = this.state;
        return (
            <div>
                <div className="tab-status-container">
                    <FieldRow>
                        {
                            this.state.tabs.map((tab, index) => 
                            <div key={index} className={tab.active ? 'tab-container active' : 'tab-container'}>
                                <span className="tab-text">
                                    <Link to={tab.path} >{tab.name}</Link>
                                </span>
                            </div>
                        )}
                        <div className="tab-line"></div>
                    </FieldRow>
                    <SupervisorTimeOffRequestModal 
                        timeOffRequest={this.state.timeOffRequest} 
                        showModal={showModal}
                        toggleModal={() => this.toggleModal()}
                        managementUnitID={ManagementUnitID}
                        status={this.state.TabType}
                    />
                </div>
                { this.renderTabs() }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        User: state.common.user
    };
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TabContainer);



// WEBPACK FOOTER //
// ./src/features/timeoff/TimeOff/TabContainer.js